import SocialMedia from "../../common/SocialMedia";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      id="footer"
      className="flex w-full flex-col items-center text-gray-500 gap-4 py-10 mt-8 border-t border-gray-800/60"
    >
      <SocialMedia />
      <div className="flex flex-col items-center gap-1 text-center">
        <span className="text-sm">Franco Martino · {year}</span>
        <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500">
          <Link
            to="/privacy-policy"
            className="hover:text-gray-300 transition-colors duration-200"
          >
            Privacidad
          </Link>
          <span aria-hidden>·</span>
          <Link
            to="/terms"
            className="hover:text-gray-300 transition-colors duration-200"
          >
            Términos
          </Link>
        </div>
      </div>
    </footer>
  );
}
